import { useDateTimeFormat } from '~/hooks';

export default function TimesheetDetails({ timesheet }) {
  const dateTimeFormat = useDateTimeFormat();
  return [timesheet.member?.name, `${dateTimeFormat.format(timesheet.start)} - ${dateTimeFormat.format(timesheet.end)}`]
    .filter(Boolean)
    .join(' - ');
}
